import { useCallback, useEffect } from 'react'

import { useEnabledInboxes } from 'conversations/hooks/useInboxes'
import { captureError } from 'conversations/utils/logRocket'
import { useDispatch } from 'react-redux'
import { setActiveInbox } from 'shared/store/actions/user'
import { Inbox } from 'shared/typings/bootstrap'
import { localStore } from 'shared/utils/storage'

const LS_KEY = 'cd_active_inbox'
const storedInbox = localStore.get(LS_KEY)

export default function useSetInbox() {
  const dispatch = useDispatch()
  const inboxes = useEnabledInboxes()

  useEffect(() => {
    if (storedInbox) {
      try {
        // init redux with locally stored inbox
        const parsedInitialInbox = JSON.parse(storedInbox)
        dispatch(setActiveInbox(parsedInitialInbox))
      } catch (err) {
        captureError(err, 'Set active inbox failed')
      }
    }
  }, [dispatch])

  const setInboxState = useCallback(
    (inbox: Inbox | null) => {
      const inboxToLocal = inbox ? JSON.stringify(inbox) : null
      localStore.set(LS_KEY, inboxToLocal)
      dispatch(setActiveInbox(inbox))
    },
    [dispatch]
  )

  useEffect(() => {
    // add local storage for single inbox users
    inboxes.length === 1 && setInboxState(inboxes[0])
  }, [inboxes, setInboxState])

  return { setInboxState }
}
